import CN from "./CN";
import TW from "./TW";

// import TW from "./CN";
// import CN from "./TW";

var lan = null;

if (process.env.NODE_ENV === "development") {
  if (navigator.language.indexOf("zh") != -1) {
    lan = CN;
    sessionStorage.setItem("Language", "zh");
  } else {
    lan = TW;
    sessionStorage.setItem("Language", "tw");
  }
} else {
  lan = TW;
  sessionStorage.setItem("Language", "tw");
}

export default lan;
